import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kNumber',
})
export class KNumberPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return '';
    const result = Number((value / 1000).toFixed(1));
    return value >= 1000 ? `${result}K` : value.toString();
  }
}
